import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Loading } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-elements/with-docs/loading/Loading';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';
import CopyableSnippet from '../../../components/utils/CopyableSnippet';
import LinkableTitle from '../../../components/linkableTitle';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<div>
<LinkableTitle name="overview" title="Themes" />
    <div className="label-block__container">
      <div className="label-block">
        <Loading />
        <div><CopyableSnippet code="primary" /></div>
      </div>
      <div className="label-block label-block--inverse">
        <Loading theme="inverse" />
        <div><CopyableSnippet code="inverse" /></div>
      </div>
    </div>
</div>
<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<Loading />`}
  scope={ { Loading } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  